// --- components/RevenueChart.jsx ---
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { useState } from "react";

export default function RevenueChart({ data }) {
  const [activePoint, setActivePoint] = useState(null);

  const handleClick = (e) => {
      e?.preventDefault?.();
  e?.stopPropagation?.();
  document.activeElement?.blur();
     setActivePoint(data[e.activeIndex]);
  };

  return (
    <div className="h-auto w-full space-y-4 ">
      <div className="h-60">
        <ResponsiveContainer>
          <AreaChart
            data={data}
            margin={{ top: 10, right: 30, left: 30, bottom: 0 }}
            onClick={handleClick}
          >
            <defs>
              <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3383B2" stopOpacity={0.3} />
                <stop offset="100%" stopColor="#3383B2" stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5f3fa" />
            <XAxis
              dataKey="name"
              tick={{ fill: "#3383B2", fontWeight: 600 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis hide />
            <Tooltip cursor={false} />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#3383B2"
              fill="url(#areaGradient)"
              strokeWidth={3}
              dot={false}
              isAnimationActive={false}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

 {activePoint && (
        <div className="bg-gray-100 p-4 rounded-lg shadow-inner">
          <div className="flex justify-between mb-2">
            <h3 className="font-semibold text-lg">Details for {activePoint.name}</h3>
            <button className="text-sm text-red-600" onClick={() => setActivePoint(null)}>
              Close
            </button>
          </div>
          <ul className="text-sm list-disc pl-5 space-y-1">
            {activePoint.details?.map((item) => (
              <li key={item.id}>
                Order ID: {item.orderId}, Amount: {item.amount}, Date: {item.date}
              </li>
            ))}
          </ul>
        </div>
      )}

    </div>
  );
}
